const displayQuestion = (session, question) => {
  const user = session.isLoggedIn ? ['All', 'LoggedInUsers'] : ['All', 'AnonymousUsers'];
  return user.find((u) => u === question.displayTo);
};
export default displayQuestion;
